import requestModule from '../libs/requestModule'
import CartController from '../controllers/CartController'
import Util from '@/assets/libs/util.js'

const cashbackCampaignParams = {
    apiUrl: Util.getLocalConfigs('apiUrlCashback')
}

// const apiHeaders = {'Authorization': 'basic dGVrbmlzYTp0ZWtuaXNh'}
const apiHeaders = {
    'Authorization': 'basic dGVrbmlzYTp0ZWtuaXNh',
    'x-client-name': 'client_name',
    'x-client-env': Util.getLocalConfigs('orgEnv'),
    'x-client-type': Util.getLocalConfigs('orgType')
}
// Events
const GET_CAMPAIGN = !Util.isOracle() ? 'sale/getCampaign' : Util.getLocalConfigs('urlOdhenInterface') + 'backend/service/index.php/sale/getCampaign'
const GET_CONSUMER = !Util.isOracle() ? 'consumer/getByPhone' : Util.getLocalConfigs('urlOdhenInterface') + 'backend/service/index.php/consumer/getByPhone'
const GET_BALANCE = cashbackCampaignParams.apiUrl + '/getBalance'
const CREDIT_BALANCE = cashbackCampaignParams.apiUrl + '/creditBalance'
const REEDEM_BALANCE = cashbackCampaignParams.apiUrl + '/redeemBalance'
const GET_SALE_RESUME = cashbackCampaignParams.apiUrl + '/getSaleResume'

const generalInfo = Util.getGeneralInfo()

let cashbackCampaign = {}
let cashbackCampaignBalance = null
let consumerData = {}
let campaignSaleResume = []

/* campanha de cashback teknisa */
const getCampaign = async function () {
    if (!cashbackCampaignParams.apiUrl) {
        return false
    }
    let hasAllParams = true
    Object.keys(apiHeaders).forEach(e => {
        if (!apiHeaders[e]) hasAllParams = false // verifica se todos os itens do header estão presentes
    })
    if (!hasAllParams) {
        return false
    }
    const ApiStatus = await requestModule.xmlRequest(cashbackCampaignParams.apiUrl, 'get', {}, apiHeaders, {})
        .then((r) => r)
        .catch((e) => {
            console.log('Falha ao consultar o endereço da API campanha de cashback')
            return false
        })
    if (!ApiStatus || !ApiStatus.root || (ApiStatus.root.error._text === 'true')) {
        return false
    }
    const campaign = await requestModule.postRequest(GET_CAMPAIGN, generalInfo)
        .then((r) => r)
        .catch((r) => false)
    if (!campaign || campaign.error || !campaign.data || !campaign.data.campaignCode) {
        console.log('Não foi encontrado nenhuma campanha de casback ativa')
        return false
    }
    cashbackCampaign = campaign.data
    return true
}

const getConsumer = async function (phone) {
    // busca o consumidor a partir do telefone
    if (!phone) {
        return false
    }
    const params = {
        subsidiaryCode: generalInfo.subsidiaryCode,
        consumerPhone: phone.replace('+', '')
    }
    const result = await requestModule.postRequest(GET_CONSUMER, params)
    if (!result || result.error || !result.data) {
        console.log('Falha ao obter o Consumidor')
        if (result.message) console.log(result.message)
        return null
    }
    return result && result.data
}

async function getCashbackCampaignBalance (phone) {
    if (!phone) {
        return false
    }
    if (!cashbackCampaign.campaignCode) {
        await getCampaign()
    }
    if (!consumerData.clientCode) {
        consumerData = await getConsumer(phone)
    }
    const params = {
        root: {
            data: {
                clientCode: consumerData.clientCode,
                consumerCode: consumerData.consumerCode,
                campaignCode: cashbackCampaign.campaignCode
            }
        }
    }
    const result = await requestModule.xmlRequest(GET_BALANCE, 'post', params, apiHeaders)
    if (!result || result.error || !result.root || !result.root.data) {
        console.log('Falha ao obter o ballance da Api de Cashback')
        console.log(getResultErrorMessage(result))
        return null
    }
    cashbackCampaignBalance = result && result.root && result.root.data
    return cashbackCampaignBalance
}

const campaignCreditBalance = async function (saleData, phone) {
    /* credita o valor de bonus para o cliente */
    if (!phone) {
        return false
    }

    if (!saleData || !cashbackCampaignBalance) {
        console.log('nao foram recebido todos os parametros necessarios para aplicar o desconto')
        return null
    }
    const params = {
        root: {
            data: {
                subsidiaryCode: generalInfo.subsidiaryCode,
                posCode: generalInfo.posCode,
                saleSeq: saleData.saleSeq,
                clientCode: consumerData.clientCode,
                consumerCode: consumerData.consumerCode,
                phone: phone.replace('+', ''),
                posOpeningDate: saleData.posOpeningDate,
                products: buildProducts()
            }
        }
    }
    let result = await requestModule.xmlRequest(CREDIT_BALANCE, 'post', params, apiHeaders)
    if (!result || result.error || !result.root || !result.root.data || result.root.error._text === 'true') {
        console.log('Falha na rotina campaignCreditBalance')
        console.log(getResultErrorMessage(result))
        return null
    }
    result = result && result.root && result.root.data
    return result
}

async function campaignRedeemBalance (saleData, phone, discount) {
    if (!phone) {
        return false
    }
    const params = {
        root: {
            data: {
                subsidiaryCode: generalInfo.subsidiaryCode,
                posCode: generalInfo.posCode,
                clientCode: consumerData.clientCode,
                consumerCode: consumerData.consumerCode,
                campaignCode: cashbackCampaign.campaignCode,
                saleSeq: saleData.saleSeq,
                phone: phone.replace('+', ''),
                posOpeningDate: saleData.posOpeningDate,
                balanceUsed: discount
            }
        }
    }
    let result = await requestModule.xmlRequest(REEDEM_BALANCE, 'post', params, apiHeaders)
    if (!result || result.error || !result.root || result.root.error._text === 'true') {
        console.log('Falha na rotina campaignReedemBalance')
        console.log(getResultErrorMessage(result))
        return null
    }
    result = result && result.root
    return result
}

async function campaignGetSaleResume (saleData, phone) {
    if (!phone) {
        return false
    }
    const params = {
        root: {
            data: {
                subsidiaryCode: generalInfo.subsidiaryCode,
                posCode: generalInfo.posCode,
                clientCode: consumerData.clientCode,
                consumerCode: consumerData.consumerCode,
                saleSeq: saleData.saleSeq,
                posOpeningDate: saleData.posOpeningDate
            }
        }
    }
    let result = await requestModule.xmlRequest(GET_SALE_RESUME, 'post', params, apiHeaders)
    if (!result || result.error || !result.root || !result.root.data || result.root.error._text === 'true') {
        console.log('Falha na rotina campaignGetSaleResume')
        console.log(getResultErrorMessage(result))
        return null
    }
    campaignSaleResume = result && result.root && result.root.data
    return campaignSaleResume
}

function buildProducts () {
    let products = []
    let prod = []
    let cart = CartController.getCart()
    /* a função price update coloca o price 0 em todos os produtos no carrinho
    que não alteram o preço, nesse caso percorre o carrinho e adiciona no products
    somente quem tem preço diferente de 0 */
    cart.forEach((e) => {
        if (e.price !== 0) {
            let item = {
                productCode: e.productCode,
                quantity: e.quantity,
                unitValue: e.price,
                totalValue: e.price
            }
            prod.push(item)
        }
        e.observations.forEach((obs) => {
            if (obs.price !== 0) {
                let item = {
                    productCode: obs.obsProductCode,
                    quantity: 1,
                    unitValue: obs.price,
                    totalValue: obs.price
                }
                prod.push(item)
            }
        })
        e.productCombo.forEach((c) => {
            if (c.price !== 0) {
                let item = {
                    productCode: c.subItemCode,
                    quantity: c.quantity,
                    unitValue: c.price,
                    totalValue: c.price
                }
                prod.push(item)
            }
            if (c.observations && c.observations.length) {
                c.observations.forEach((cObs) => {
                    if (cObs.price !== 0) {
                        let item = {
                            productCode: cObs.subItemObsProductCode,
                            quantity: 1,
                            unitValue: cObs.price,
                            totalValue: cObs.price
                        }
                        prod.push(item)
                    }
                })
            }
            if (c.choosen) {
                Object.keys(c.choosen).forEach((key) => {
                    c.choosen[key].forEach((cc) => {
                        if (cc.price !== 0) {
                            let item = {
                                productCode: cc.subItemCode,
                                quantity: 1,
                                unitValue: cc.price,
                                totalValue: cc.price
                            }
                            prod.push(item)
                        }
                        if (cc.observations && cc.observations.length) {
                            cc.observations.forEach((ccObs) => {
                                if (ccObs.price !== 0) {
                                    let item = {
                                        productCode: ccObs.subItemObsProductCode,
                                        quantity: 1,
                                        unitValue: ccObs.price,
                                        totalValue: ccObs.price
                                    }
                                    prod.push(item)
                                }
                            })
                        }
                    })
                })
            }
        })
    })
    products = [{
        'prod': prod
    }]
    return products
}

function getResultErrorMessage (result) {
    let errorMessage = (result && result.message && result.message.root && result.message.root.message && result.message.root.message._text) ||
    result.message || null
    return errorMessage
}

export default {
    getCampaign,
    getCashbackCampaignBalance,
    campaignCreditBalance,
    campaignRedeemBalance,
    campaignGetSaleResume,
    campaignGetBalanceResume: () => {
        if (campaignSaleResume && campaignSaleResume.balance) {
            return {
                campaignEnabled: 2,
                expiration: campaignSaleResume.balance.expiration._text,
                generatedBalance: campaignSaleResume.balance.generatedBalance._text,
                redeemBalance: campaignSaleResume.balance.redeemBalance._text,
                totalBalance: campaignSaleResume.balance.totalBalance._text
            }
        }
        return null
    },
    getCashbackBonusValue: () => {
        if (cashbackCampaignBalance && cashbackCampaignBalance.balance && cashbackCampaignBalance.balance._text) {
            return {
                available: parseFloat(cashbackCampaignBalance.balance._text),
                maxValue: parseFloat(cashbackCampaignBalance.balance._text)
            }
        }
        return {
            available: 0,
            maxValue: 0
        }
    },
    getConsumerData: () => {
        if (consumerData) {
            return {
                consumerData: consumerData,
                campaignEnabled: 3
            }
        }
        return null
    },
    clearCampaignData: () => {
        cashbackCampaign = {}
        cashbackCampaignBalance = null
        consumerData = {}
        campaignSaleResume = []
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/CampaignFidelityTEKController.js